document.addEventListener("DOMContentLoaded", function () {
  // Register GSAP plugins
  gsap.registerPlugin(ScrollTrigger);

  // Lazy load the background image
  const lazyImage = document.querySelector("#background-image");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        lazyImage.src = lazyImage.dataset.src; // Load the image
        lazyImage.onload = () => lazyImage.classList.add("loaded"); // Add the fade-in effect
        observer.unobserve(lazyImage); // Stop observing after loading
      }
    });
  });
  observer.observe(lazyImage);

  // Scroll-triggered background movement
  gsap.to("#background-image", {
    y: "-50%", // Move the image upward throughout the scroll
    ease: "none",
    scrollTrigger: {
      trigger: ".about-section",
      start: "top top",
      end: "bottom+=1000 top", // Extend scroll duration
      scrub: true, // Smooth scrubbing for the background
    },
  });

  // Animate each section smoothly
  gsap.utils.toArray(".section").forEach((section) => {
    gsap.fromTo(
      section,
      { yPercent: 20, opacity: 0 }, // Start below with no opacity
      {
        yPercent: 0, // Move to its original position
        opacity: 1,
        duration: 1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 90%", // Start animation as the section enters the viewport
          end: "top 40%", // Animation completes closer to the center
          scrub: true, // Smooth scrolling effect
        },
      }
    );
  });

  // Pause other videos when one starts playing
  const videos = document.querySelectorAll("iframe");

  // Add YouTube API support
  videos.forEach((video) => {
    const src = video.src;
    if (!src.includes("enablejsapi=1")) {
      video.src = src.includes("?") ? `${src}&enablejsapi=1` : `${src}?enablejsapi=1`;
    }
  });

  // Listen for play events
  const players = [];

  function onYouTubeIframeAPIReady() {
    videos.forEach((video) => {
      const player = new YT.Player(video, {
        events: {
          onStateChange: (event) => {
            if (event.data === YT.PlayerState.PLAYING) {
              players.forEach((p) => {
                if (p !== player) {
                  p.pauseVideo();
                }
              });
            }
          },
        },
      });
      players.push(player);
    });
  }

  // Load the YouTube IFrame API
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Ensure the API loads
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
});
